import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Loader, TabsPanel } from '../../ui';
import { useRegions } from '../../shared/hooks';
import { ratingTypes } from '../../shared/constants/ratingTypes';
import { getSearchResultEntitiesByRatingType } from '../../selectors/common';
import { EntitiesTable } from '../../modules/common';
import { searchEntitiesAction } from '../../store/searchResult/searchResultActions';

export const CreditRatingCoverage: FC = () => {
  const { t } = useTranslation();
  const { countryId } = useParams();
  const entities = useSelector(getSearchResultEntitiesByRatingType(ratingTypes.CREDIT_RATING));
  const regions = useRegions();
  const initialCountry = regions.data.filter((value) => value.iso === countryId);
  if (regions.isPending) {
    return <Loader center />;
  }

  return (
    <>
      <Box mb={2}>
        <Typography variant="h5">{t('Credit Rating Coverage')}</Typography>
      </Box>
      {/* @ts-ignore */}
      <TabsPanel active="entities">
        <div label={t('Entities')} value="entities" counter={entities.total}>
          <EntitiesTable
            dataSelector={entities}
            actionCreator={searchEntitiesAction}
            actionCreatorParams={{ ratingType: ratingTypes.CREDIT_RATING }}
            constantFilter={{ withRatingOnly: true }}
            ratingType={ratingTypes.CREDIT_RATING}
            initialFilter={{
              countries: [countryId],
            }}
            initialFilterModalValues={{ countries: initialCountry }}
          />
        </div>
      </TabsPanel>
    </>
  );
};
